import 'babel-polyfill';
import { IndexRoute, Route, hashHistory, browserHistory, Redirect } from 'react-router';
import React from 'react';
import ReactDOM from 'react-dom';
import { RelayRouter } from 'react-router-relay';
import StoreQueries from './queries/StoreQueries';
import Main from './components/Main';
import SearchResults from './components/SearchResults';
import Objects from './components/Object/List';
import ObjectDetail from './components/Object/Detail';
import PersonDetail from './components/Person/Detail';
import Designers from './components/Person/Designers'
import Producers from './components/Person/Producers'
import ContentList from './components/Content/List'
import ObjectListByCategoryId from './components/Object/List/ByCategoryId'
import ObjectListByCategoryName from './components/Object/List/ByCategoryName'
import Overlay from './components/Overlay'
import MyCollection from './components/MyCollection'
import settings from '../config/settings';
import {
    resetLocalData,
    setLanguage,
    getCurrentLanguage,
    getSearchFields,
    getMyCollection,
    deActivateNavigation,
    toggleIsNavigationActive,
    resetSearchFields,
    setIsForKids,
    showTextForKids,

} from './localData';
import {
    expireVisit,
    redirectIfVisitExpired,
} from './expiration';


require('../styles/vendor/normalize.css');
require('./app.scss');
require('../styles/helpers.scss');

// Start timestamp for expiration of visit if configured
expireVisit();
redirectIfVisitExpired();

resetLocalData();
const urlParts = location.hash.split('/');
const l = urlParts[0] === '#' ? urlParts[1] : urlParts[0];

if (settings.languages.indexOf(l) > -1) {
    setLanguage(l);
} else {
    setLanguage(settings.defaultLanguage || 'de');
}

deActivateNavigation();
// toggleIsNavigationActive();

const checkIsForKids = () => {
    const hash = window.location.hash;
    const navItem = settings.navigation.find(item => item.name === 'objForKids');
    const noKidsRoutes = ['/search', '/objects', '/designers', '/content', '/category'];
    let isForKids = false;

    if (hash.indexOf(navItem.url) > -1) {
        isForKids = true;
    } else {
        isForKids = showTextForKids();
        noKidsRoutes.map(r => {
            if (hash.indexOf(r) > -1) {
                isForKids = false;
            }
        });
    }
    setIsForKids(isForKids);
};

function prepareLanguageParams(params) {
    checkIsForKids();

    const lang = getCurrentLanguage();
    return {
        ...params,
        lang,
    };
}

function prepareAllPersonsParams(params) {
    const lang = prepareLanguageParams(params);
    const nameStartsWith = null;

    return {
        ...lang,
        nameStartsWith,
    };
}

function prepareSearchParams(params) {
    const lang = prepareLanguageParams(params);
    const searchFields = getSearchFields();

    return {
        ...lang,
        ...searchFields,
    };
}

function prepareResetSearchParams(params) {
    const lang = prepareLanguageParams(params);

    resetSearchFields();
    const searchFields = getSearchFields();

    return {
        ...lang,
        ...searchFields,
    };
}

function prepareMyCollectionParams(params) {
    const lang = prepareLanguageParams(params);
    const myCollection = getMyCollection();
    const objectsIds = myCollection.objects;
    const designersIds = myCollection.designers;
    const producersIds = myCollection.producers;

    return {
        ...lang,
        objectsIds,
        designersIds,
        producersIds,
    };
}

const renderLoading = () => (
    <div></div>
);

ReactDOM.render(
    <RelayRouter history={ hashHistory } forceFetch={true}>
        <Route
            path="/(:lang/)"
            component={ Main }
            queries={ StoreQueries }
            prepareParams={prepareSearchParams}
            renderLoading={() => renderLoading()}
        >
            <Route
                path="/:lang/search"
                component={ SearchResults }
                queries={ StoreQueries }
                prepareParams={prepareSearchParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/search' to={`/${getCurrentLanguage()}/search`} />
            <Route
                path="/:lang/objects"
                component={ Objects }
                queries={ StoreQueries }
                prepareParams={prepareResetSearchParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/objects' to={`/${getCurrentLanguage()}/objects`} />
            <Route
                path="/:lang/designers"
                component={ Designers }
                queries={ StoreQueries }
                prepareParams={prepareAllPersonsParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/designers' to={`/${getCurrentLanguage()}/designers`} />
            <Route
                path="/:lang/designers/:nameStartsWith"
                component={ Designers }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/designers/:nameStartsWith' to={`/${getCurrentLanguage()}/designers/:nameStartsWith`} />
            <Route
                path="/:lang/producers"
                component={ Producers }
                queries={ StoreQueries }
                prepareParams={prepareAllPersonsParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/producers' to={`/${getCurrentLanguage()}/producers`} />
            <Route
                path="/:lang/producers/:nameStartsWith"
                component={ Producers }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/producers/:nameStartsWith' to={`/${getCurrentLanguage()}/producers/:nameStartsWith`} />
            <Route
                path="/:lang/contents/:conType"
                component={ ContentList }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Route
                path="/:lang/content/:categoryId/objects"
                component={ ObjectListByCategoryId }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/content/:categoryId/objects' to={`/${getCurrentLanguage()}/content/:categoryId/objects`} />
            <Route
                path="/:lang/category/:category/objects"
                component={ ObjectListByCategoryName }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/category/:category/objects' to={`/${getCurrentLanguage()}/category/:category/objects`} />
            <Route
                path="/:lang/mycollection"
                component={ MyCollection }
                queries={ StoreQueries }
                prepareParams={prepareMyCollectionParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/mycollection' to={`/${getCurrentLanguage()}/mycollection`} />
            <Route
                path="/:lang/object/:id"
                component={ ObjectDetail }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/object/:id' to={`/${getCurrentLanguage()}/object/:id`} />
            <Route
                path="/:lang/person/:id"
                component={ PersonDetail }
                queries={ StoreQueries }
                prepareParams={prepareLanguageParams}
                renderLoading={() => renderLoading()}
            />
            <Redirect from='/person/:id' to={`/${getCurrentLanguage()}/person/:id`} />
        </Route>
        <Route
            path="/overlay/:id"
            component={ Overlay }
            queries={ StoreQueries }
            prepareParams={prepareLanguageParams}
            renderLoading={() => renderLoading()}
        />
        <Route
            path="/:lang/overlay/:id"
            component={ Overlay }
            queries={ StoreQueries }
            prepareParams={prepareLanguageParams}
            renderLoading={() => renderLoading()}
        />
    </RelayRouter>,
    document.getElementById('app')
);



// WEBPACK FOOTER //
// ./app/app.js